var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"chartDivNormal",staticClass:"gaugeNormal",attrs:{"id":"chartDivNormal"}},[_c('VueGauge',{key:_vm.rerenderKey,staticStyle:{"margin":"auto 0"},attrs:{"refid":`gauge${_vm.deviceData.id}`,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }